import { render, staticRenderFns } from "./previewExamScore.vue?vue&type=template&id=0f1d382e&scoped=true&"
import script from "./previewExamScore.vue?vue&type=script&lang=js&"
export * from "./previewExamScore.vue?vue&type=script&lang=js&"
import style0 from "./previewExamScore.vue?vue&type=style&index=0&id=0f1d382e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1d382e",
  null
  
)

export default component.exports